<script setup lang="ts">
import { PropType } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Category from '../model/category';


const props = defineProps({
  marker: {
    type: Object as PropType<Category>,
    required: true,
  },
});

const router = useRouter();
const route = useRoute();
const select = (name: string, returnTo?: string) => { router.push({ name: 'category', params: { category: name.toString().toLocaleLowerCase() }, query: { returnTo } }); };

const facture: string = "Facture",
  devis: string = "Devis";

const testCatg = (): boolean => {
  let result = [facture, devis].includes(props.marker.name) ? true : false;
  return result;
};

</script>

<style>
.pointer {
  cursor: pointer;
}
</style>

<template>
  <!-- Bouton retour (si présent) - affiché pour toutes les pages -->
  <div v-if="route.query.returnTo" class="xl:mt-6 mt-4 mb-3 flex justify-end">
    <button
      class="
        inline-flex
        items-center
        gap-1.5
        px-3
        py-1.5
        text-sm
        bg-white
        dark:bg-gray-800
        border
        border-blue-300
        dark:border-blue-700
        text-gray-900
        dark:text-gray-100
        font-medium
        rounded
        hover:border-blue-500
        dark:hover:border-blue-500
        hover:bg-blue-50
        dark:hover:bg-blue-900/20
        transition-colors
        duration-150
        shadow-sm
        cursor-pointer
        capitalize
      "
      @click="select(route.query.returnTo as string)"
    >
      <fa :icon="['far', 'arrow-left']" class="text-blue-600 dark:text-blue-400" />
      <span>Retour à {{ route.query.returnTo }}</span>
    </button>
  </div>

  <!-- Section d'information et navigation -->
  <div v-if="testCatg()" class="mb-6">
    <!-- Panneau explicatif avec couleur douce -->
    <div class="
        p-4
        bg-blue-50
        dark:bg-blue-900/10
        border
        border-blue-200
        dark:border-blue-800/30
        rounded-lg
      ">
      <div class="flex items-start gap-3 mb-3">
        <div class="
            flex-shrink-0
            w-8
            h-8
            flex
            items-center
            justify-center
            rounded-full
            bg-blue-100
            dark:bg-blue-900/30
            text-blue-700
            dark:text-blue-400
          ">
          <fa :icon="['far', 'lightbulb']" class="text-sm" />
        </div>
        <div class="flex-1">
          <h3 class="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-1">
            Marqueurs additionnels disponibles
          </h3>
          <p class="text-sm text-blue-800 dark:text-blue-200 mb-3">
            <span v-if="'Facture' === props.marker.name">
              Lorsqu'une facture est associée à un <strong>dossier</strong> ou à un <strong>groupe</strong>
              dans téo, tous les marqueurs de ces entités deviennent disponibles dans votre modèle de facture.
            </span>
            <span v-if="'Devis' === props.marker.name">
              Lorsqu'un devis est associé à un <strong>dossier</strong> ou à un <strong>groupe</strong>
              dans téo, tous les marqueurs de ces entités deviennent disponibles dans votre modèle de devis.
            </span>
          </p>

          <!-- Boutons de navigation -->
          <div class="flex flex-wrap gap-2">
            <button
              class="
                inline-flex
                items-center
                gap-1.5
                px-3
                py-1.5
                text-sm
                bg-white
                dark:bg-gray-800
                border
                border-blue-300
                dark:border-blue-700
                text-gray-900
                dark:text-gray-100
                font-medium
                rounded
                hover:border-blue-500
                dark:hover:border-blue-500
                hover:bg-blue-50
                dark:hover:bg-blue-900/20
                transition-colors
                duration-150
                shadow-sm
                cursor-pointer
              "
              @click="select('dossier', route.params.category as string)">
              <fa :icon="['far', 'folder-open']" class="text-blue-600 dark:text-blue-400" />
              <span>Voir les marqueurs Dossier</span>
              <fa :icon="['fas', 'arrow-right']" class="text-xs" />
            </button>

            <button
              class="
                inline-flex
                items-center
                gap-1.5
                px-3
                py-1.5
                text-sm
                bg-white
                dark:bg-gray-800
                border
                border-blue-300
                dark:border-blue-700
                text-gray-900
                dark:text-gray-100
                font-medium
                rounded
                hover:border-blue-500
                dark:hover:border-blue-500
                hover:bg-blue-50
                dark:hover:bg-blue-900/20
                transition-colors
                duration-150
                shadow-sm
                cursor-pointer
              "
              @click="select('groupe', route.params.category as string)">
              <fa :icon="['far', 'users']" class="text-blue-600 dark:text-blue-400" />
              <span>Voir les marqueurs Groupe</span>
              <fa :icon="['fas', 'arrow-right']" class="text-xs" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
